import axios from "../axiosConfig";

class Routes {

 
    login= (val) => {
        let data = axios.post("/api/login", val);
        return data;
    };
    Register= (val) => {
        let data = axios.post("/api/register", val);
        return data;
    };
    // silent: true suppresses the shared error toast — this runs in the
    // background on app load, and a failed background refresh shouldn't
    // interrupt someone who hasn't touched anything themselves.
    refreshToken = () => {
        // {} not null: axios serialises a null body to the literal string
        // "null", which express.json() rejects with a 400 — so every refresh
        // silently failed and sessions never actually renewed.
        let data = axios.post("/api/refresh-token", {}, { silent: true });
        return data;
    };

}



export default new Routes();